import { render, staticRenderFns } from "./ColorsTable.vue?vue&type=template&id=21f44134&"
import script from "./ColorsTable.vue?vue&type=script&lang=js&"
export * from "./ColorsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports